import React from 'react';
import { useTranslation } from "react-i18next";
import { ReactComponent as Statistics } from "Assets/icons/statistics.svg";
import { ReactComponent as OffersAnnouncement } from "Assets/icons/offersAnnouncement.svg";
import { ReactComponent as Tradeboard } from "Assets/icons/tradeboard.svg";
import { ReactComponent as PowerMarketIcon } from "Assets/icons/powerMarket.svg";
import { ReactComponent as OtherAnnouncements } from "Assets/icons/otherAnnouncements.svg";
import { ReactComponent as CalculatorIcon } from "Assets/icons/calculator.svg";
const PowerMarket = () => {
    const { t, i18n } = useTranslation();
    const currentLang = i18n.language;

    return (
        <div className="megaMenuContent">
            <div className="row h-100 align-items-center">
                <div className="col-9">
                    <div className="row">
                        <div className="col-5 d-flex justify-content-center align-items-center mb-3">
                            <a href="/Market/PowerMarket/TradeBoard" className="tradesFeeItems py-2 px-4 w-100">
                                <Tradeboard
                                    className="max-width-100 mx-2 d-inline-block"
                                />

                                {t('electricity_market_board')}
                            </a>
                        </div>
                        <div className="col-5 d-flex justify-content-center align-items-center mb-3">
                            <a href="/Market/PowerMarket/Announcements" className="tradesFeeItems py-2 px-4 w-100">
                                <OtherAnnouncements
                                    className="max-width-100 mx-2 d-inline-block"
                                />
                                {t('electricity_market_other_notices')}
                            </a>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-5 d-flex justify-content-center align-items-center mb-3">
                            <a href="/Market/PowerMarket/OffersAnnouncements" className="tradesFeeItems py-2 px-4 w-100">
                                <OffersAnnouncement
                                    className="max-width-100 mx-2 d-inline-block"
                                />
                                {t('electricity_market_notices')}
                            </a>
                        </div>
                        <div className="col-5 d-flex justify-content-center align-items-center mb-3">
                            <a href="/Markets/PowerMarket/PowerCalculator" className="tradesFeeItems py-2 px-4 w-100">
                                <CalculatorIcon
                                    className="max-width-100 mx-2 d-inline-block"
                                />
                                {t('electricity_calculator')}
                            </a>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-5 d-flex justify-content-center align-items-center mb-3">
                            <a href="/Market/PowerMarket/Statistics" className="tradesFeeItems py-2 px-4 w-100">
                                <Statistics
                                    className="max-width-100 mx-2 d-inline-block"
                                />
                                {t('electricity_market_stats')}
                            </a>
                        </div>
                    </div>
                </div>
                <div className="col-3 d-flex justify-content-center align-items-center">
                    <PowerMarketIcon
                        width={"100%"}
                        height={"100%"}
                        className="w-100 mx-2 d-block text-blue p-5"
                    />
                </div>

            </div>

        </div>
    );
};

export default PowerMarket;
